
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/auth/login";
import Signup from "../pages/auth/signup";
import QRGenerator from "../pages/qr-generator/page";
import QRScanner from "../pages/qr-scanner/page";
import QRSelectPage from "../pages/qr-select/page";
import QRLinkPage from "../pages/qr-link/page";
import Dashboard from "../pages/dashboard/page";
import SpeakerNotesPage from "../pages/dashboard/components/SpeakerNotesPage";
import SharePage from "../pages/dashboard/components/SharePage";
import FolderPage from "../pages/dashboard/components/FolderPage";
import PresentationViewer from "../pages/presentations/[id]/page";
import PresentationRemote from "../pages/presentations/[id]/remote/page";
import SharedViewerPage from "../pages/shared/page";
import Landing from "../pages/landing/page";
import AuthCallback from "../pages/auth/callback";
import RedirectIfAuthenticated from "../components/RedirectIfAuthenticated";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <RedirectIfAuthenticated><Login /></RedirectIfAuthenticated>,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/auth/callback",
    element: <AuthCallback />,
  },
  {
    path: "/qr-generator",
    element: <QRGenerator />,
  },
  {
    path: "/qr-scanner",
    element: <QRScanner />,
  },
  {
    path: "/qr-select",
    element: <QRSelectPage />,
  },
  {
    path: "/qr-link",
    element: <QRLinkPage />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/presentations/:id",
    element: <PresentationViewer />,
  },
  {
    path: "/presentations/:id/remote",
    element: <PresentationRemote />,
  },
  {
    path: "/dashboard/speaker-notes",
    element: <SpeakerNotesPage />,
  },
  {
    path: "/dashboard/share",
    element: <SharePage />,
  },
  {
    path: "/dashboard/folder",
    element: <FolderPage />,
  },
  {
    path: "/shared/:token",
    element: <SharedViewerPage />,
  },
  {
    path: "/landing",
    element: <Landing />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
